// Browser-floor gate surface (THEME.md law 10) — rendered by the v4 shell
// INSTEAD of the provider/router tree when src/lib/browserSupport.ts fails
// feature detection, so it must stay dependency-light (APStatusView idiom).
// On the very browsers that land here the oklch tokens don't resolve; the
// page degrades to default text colors and stays legible by design.
import { DangerCircleBold } from '@assessprep/icons/solar';
import { useTranslation } from 'react-i18next';

// APL-11850 (v3 parity): lockdown users need Quit exactly when things break —
// the quit affordance must not depend on fetching a chunk.
import { QuitButton } from '@/components/ap/lockdown/QuitButton';
import { APStatusView } from '@/components/ap/status/APStatusView';
import { getAppType } from '@/lib/offline/OfflineAppHelper';

export const UnsupportedBrowserPage = () => {
  const { t } = useTranslation();
  const appType = getAppType();

  return (
    <APStatusView
      fullScreen
      tone="danger"
      icon={<DangerCircleBold />}
      title={t('UnsupportedBrowserNotice.browser_not_supported')}
      description={
        <span className="flex flex-col gap-2 text-start">
          <span>{t('UnsupportedBrowserNotice.this_browser_version_cannot_run_assessprep')}</span>
          <span>{t('UnsupportedBrowserNotice.safari_update_macos_hint')}</span>
          <span>{t('UnsupportedBrowserNotice.chrome_edge_firefox_update_hint')}</span>
          <span>{t('UnsupportedBrowserNotice.chromebook_expiry_hint')}</span>
        </span>
      }
      testId="v4-unsupported-browser"
      actions={
        appType !== 'web' ? <QuitButton quitButtonText={t('ViewCard.quit_app')} /> : undefined
      }
    />
  );
};
